{
  "name": "risk-assessment",
  "version": "0.1.6",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "lint": "ng lint",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "build:container": "ng run risk-assessment:ngsscbuild:production",
    "cy:open": "cypress open",
    "commitlint": "commitlint --edit",
    "prepare": "husky",
    "release": "release-it",
    "pull": "git stash && git pull && git stash apply",
    "generate": "graphql-codegen",
    "generate2": "graphql-codegen --config codegen-planner-tool.ts"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^18.0.2",
    "@angular/common": "^18.0.2",
    "@angular/compiler": "^18.0.2",
    "@angular/core": "^18.0.2",
    "@angular/forms": "^18.0.2",
    "@angular/platform-browser": "^18.0.2",
    "@angular/platform-browser-dynamic": "^18.0.2",
    "@angular/router": "^18.0.2",
    "@apollo/client": "^3.0.0",
    "@azure/msal-angular": "^3.0.17",
    "@azure/msal-browser": "^3.14.0",
    "@fortawesome/fontawesome-free": "^6.5.2",
    "@fortawesome/free-solid-svg-icons": "^6.5.2",
    "@ngrx/effects": "^18.1.1",
    "@ngrx/entity": "^18.1.1",
    "@ngrx/store": "^18.1.1",
    "@ngrx/store-devtools": "^18.1.1",
    "@ngx-translate/core": "^15.0.0",
    "@ngx-translate/http-loader": "^8.0.0",
    "angular-server-side-configuration": "^18.2.0",
    "apollo-angular": "^7.0.1",
    "chart.js": "^4.4.4",
    "graphql": "^16",
    "http": "^0.0.1-security",
    "husky": "^9.0.11",
    "primeflex": "^3.3.1",
    "primeicons": "^6.0.1",
    "primeng": "^17.16.1",
    "quill": "^2.0.3",
    "rxjs": "~7.8.0",
    "sanitize-html": "^2.17.0",
    "tslib": "^2.3.0",
    "undici": "^6.19.2",
    "ws": "^8.17.1",
    "zone.js": "~0.14.3"
  },
  "devDependencies": {
    "@angular-devkit/architect": "^0.1800.0",
    "@angular-devkit/build-angular": "^18.0.3",
    "@angular-eslint/builder": "18.2.0",
    "@angular-eslint/eslint-plugin": "18.2.0",
    "@angular-eslint/eslint-plugin-template": "18.2.0",
    "@angular-eslint/schematics": "18.2.0",
    "@angular-eslint/template-parser": "18.2.0",
    "@angular/cli": "^18.0.3",
    "@angular/compiler-cli": "^18.0.2",
    "@commitlint/cli": "^19.3.0",
    "@commitlint/config-conventional": "^19.2.2",
    "@compodoc/compodoc": "^1.1.25",
    "@graphql-codegen/cli": "^5.0.2",
    "@graphql-codegen/introspection": "^4.0.3",
    "@graphql-codegen/typed-document-node": "^5.0.9",
    "@graphql-codegen/typescript": "^4.0.9",
    "@graphql-codegen/typescript-apollo-angular": "^4.0.0",
    "@graphql-codegen/typescript-operations": "^4.2.3",
    "@ngrx/schematics": "^17.1.0",
    "@release-it/conventional-changelog": "^8.0.1",
    "@types/jasmine": "~5.1.0",
    "@types/sanitize-html": "^2.16.0",
    "@typescript-eslint/eslint-plugin": "7.11.0",
    "@typescript-eslint/parser": "7.11.0",
    "@typescript-eslint/utils": "^8.0.0-alpha.28",
    "cypress": "^13.6.3",
    "eslint": "8.57.0",
    "eslint-config-prettier": "^9.0.0",
    "husky": "^9.0.11",
    "jasmine-core": "~5.1.0",
    "jsonc-eslint-parser": "^2.1.0",
    "karma": "^6.3.17",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "release-it": "^17.2.1",
    "sass": "^1.77.3",
    "typescript": "~5.4.5"
  },
  "overrides": {
    "axios": "1.13.5",
    "handlebars": "^4.7.9",
    "shell-quote": "^1.10.0",
    "websocket-driver": "^0.7.5",
    "tar": "^7.5.22"
  }
}